import { Finalidades, FinalidadesClaro } from "./finalidades.model";

export class Pedidos {
  idPedido: string;
  documento: string;
  status: string;
  dataCriacao: Date;
  dataAtualizacao: Date;
  dataExpiracao: Date;
  purposes: Finalidades[];
  attendantLogin: string;
  middle: number;
  clientEmail: string;
  clientName: string;
  origin: number;
  protocol: string;
  dtStart: Date;
  dtEnd: Date;
  purposeClaro:FinalidadesClaro


}
